import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Change Password")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "container mw-md-50" }
const _hoisted_5 = { class: "card-footer" }
const _hoisted_6 = { class: "container mw-md-50" }
const _hoisted_7 = { class: "d-flex flex-row gap-2 justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewPasswordForm = _resolveComponent("NewPasswordForm")!
  const _component_ChangePasswordForm = _resolveComponent("ChangePasswordForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.authUser.create_new_password)
          ? (_openBlock(), _createBlock(_component_NewPasswordForm, {
              key: 0,
              onSubmitForm: _ctx.handleSubmitForm,
              loading: _ctx.loading
            }, null, 8, ["onSubmitForm", "loading"]))
          : (_openBlock(), _createBlock(_component_ChangePasswordForm, {
              key: 1,
              onSubmitForm: _ctx.handleSubmitForm,
              loading: _ctx.loading
            }, null, 8, ["onSubmitForm", "loading"]))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef))),
            class: "btn btn-primary align-self-center"
          }, " Submit "),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetForm(_ctx.ruleFormRef))),
            class: "btn btn-secondary align-self-center"
          }, " Reset ")
        ])
      ])
    ])
  ]))
}